module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ded"
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Body ParaOverride-3"
  }, [_c('span', {
    staticClass: "Italics CharOverride-2"
  }, [_vm._v("To Jack: Never forget the strength that lies")]), _vm._v(" "), _c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("within you and your ability to achieve anything.")]), _vm._v(" "), _c('span', {
    staticClass: "Italics CharOverride-2"
  }, [_vm._v("You make a positive impact on the world every day simply because of who you are.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "Body ParaOverride-3"
  }, [_c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("With love,")])]), _vm._v(" "), _c('p', {
    staticClass: "Body ParaOverride-3"
  }, [_c('span', {
    staticClass: "Italics _idGenCharOverride-1"
  }, [_vm._v("Your biggest fan")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c1d7ba6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05-ded.vue
// module id = 69
// module chunks = 0